import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithAwsS3_1 from '../../../../..//libraries/Images/createAConnectionWithAwsS3_1.png';
import createAConnectionWithAwsS3_2 from '../../../../..//libraries/Images/createAConnectionWithAwsS3_2.png';
import createAConnectionWithAwsS3_3 from '../../../../..//libraries/Images/createAConnectionWithAwsS3_3.png';
import createAConnectionWithAwsS3_4 from '../../../../..//libraries/Images/createAConnectionWithAwsS3_4.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithawss3">
                1.&nbsp;{translate('createaconnectionwithawss3')}
            </Typography>
            <p>Click "Add New" to create the connection.</p>
            <Zoom>
                <img src={createAConnectionWithAwsS3_1} width="75%" />
            </Zoom>
            <p>A list of applications that can be linked will appear, select "Aws S3" from among them.</p>
            <Zoom>
                <img src={createAConnectionWithAwsS3_2} width="75%" />
            </Zoom>
            <p>After you click "Aws S3", please enter the required values and then click OK button to finish.</p>
            <Zoom>
                <img src={createAConnectionWithAwsS3_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>You will see an Aws S3 card once the connection is successfully created.</p>
            <Zoom>
                <img src={createAConnectionWithAwsS3_4} width="50%" />
            </Zoom>
            <p>Use the <strong>Provider ID</strong> included in this tag to perform the steps in Aws S3.</p>
            <br/>
        </Box>
    );
}
export default withTranslate(En);